// @flow

import React from 'react';
import bemify from 'bemify-js';

import SimplePromo, {
  type SimplePromoProps,
} from 'app/login/components/SimplePromo';
import { PlatformContainerWhyFeaturedItems } from 'app/login/components/FeatureItems';
import 'app/login/components/PlatformPromo.scss';

const bem = bemify('platform-signup');

export type Props = SimplePromoProps & {
  createPotentialPartner: (data: {
    email: string,
    has_api?: boolean,
    company_web_site?: string,
  }) => void,
  resetPotentialPartner: () => void,
  isSaving: boolean,
  errors: Array<string>,
  hasSubmitted: boolean,
};

const PlatformPromoSignUp = (props: Props) => {
  return (
    <React.Fragment>
      <SimplePromo
        {...props}
        className={bem('__simple-promo')}
        condensedIcon="info"
        title="Why build an integration?"
      >
        <PlatformContainerWhyFeaturedItems />
      </SimplePromo>
    </React.Fragment>
  );
};

export default PlatformPromoSignUp;
